module.exports = __webpack_public_path__ + "img/banner2.f81ac006.jpg";